import React from "react";

const RepLocation = props => (
    <form action="/" className="rep-search-container" onSubmit={props.onSubmit}>
        <input type="submit" className="sr-only" />
        <div className="map-search-box col-lg-2">
            <label className="sr-only" htmlFor="zipcode">
                Enter a Zipcode
            </label>
            <input
                className="form-control"
                type="text"
                id="zipcode"
                name="zipcode"
                value={props.zipcode}
                placeholder="enter postal code"
                onChange={props.onChange}/>
        </div>
        <h5 className="search-decision">Or</h5>
        <div className="map-search-box col-lg-3 ">
            <label className="sr-only" htmlFor="city">
                Enter a City
            </label>
            <input
                className="form-control"
                id="city"
                type="text"
                name="city"
                value={props.city}
                placeholder="enter city"
                onChange={props.onChange}/>
        </div>
        <div className="map-search-box filter-dropdown col-lg-2 ">
            <label className="sr-only" htmlFor="state">
                Enter a State
            </label>
            <select
                className="form-control small-font"
                id="state"
                name="state"
                onChange={props.onChange}
                value={props.state}
                >

                <option value="" hidden selected disabled>
                    Choose State...
                </option>
                <option value="Alabama">AL</option>
                <option value="Alaska">AK</option>
                <option value="Arizona">AZ</option>
                <option value="Arkansas">AR</option>
                <option value="California">CA</option>
                <option value="Colorado">CO</option>
                <option value="Connecticut">CT</option>
                <option value="Delaware">DE</option>
                <option value="District Of Columbia">DC</option>
                <option value="Florida">FL</option>
                <option value="Georgia">GA</option>
                <option value="Hawaii">HI</option>
                <option value="Iowa">IA</option>
                <option value="Idaho">ID</option>
                <option value="Illinois">IL</option>
                <option value="Indiana">IN</option>
                <option value="Kansas">KS</option>
                <option value="Kentucky">KY</option>
                <option value="Louisiana">LA</option>
                <option value="Maine">ME</option>
                <option value="Maryland">MD</option>
                <option value="Massachusetts">MA</option>
                <option value="Michigan">MI</option>
                <option value="Minnesota">MN</option>
                <option value="Mississippi">MS</option>
                <option value="Missouri">MO</option>
                <option value="Montana">MT</option>
                <option value="Nebraska">NE</option>
                <option value="Nevada">NV</option>
                <option value="New Hampshire">NH</option>
                <option value="New Jersey">NJ</option>
                <option value="New Mexico">NM</option>
                <option value="New York">NY</option>
                <option value="North Carolina">NC</option>
                <option value="North Dakota">ND</option>
                <option value="Ohio">OH</option>
                <option value="Oklahoma">OK</option>
                <option value="Oregon">OR</option>
                <option value="Pennsylvania">PA</option>
                <option value="Rhode Island">RI</option>
                <option value="South Carolina">SC</option>
                <option value="South Dakota">SD</option>
                <option value="Tennessee">TN</option>
                <option value="Texas">TX</option>
                <option value="Utah">UT</option>
                <option value="Vermont">VT</option>
                <option value="Virginia">VA</option>
                <option value="Washington">WA</option>
                <option value="West Virginia">WV</option>
                <option value="Wisconsin">WI</option>
                <option value="Wyoming">WY</option>
                <option disabled>- Canadian Provinces -</option>
                <option value="Alberta">AB</option>
                <option value="British Columbia">BC</option>
                <option value="Manitoba">MB</option>
                <option value="New Brunswick">NB</option>
                <option value="Nova Scotia">NS</option>
                <option value="Ontario">ON</option>
                <option value="Quebec">QC</option>
                <option value="Saskatchewan">SK</option>
            </select>
        </div>
        <div className="map-search-box filter-dropdown col-lg-2">
            <label className="sr-only" htmlFor="distance">
                Enter a Distance
            </label>
            <select
                className="form-control"
                name="distance"
                id="distance"
                onChange={props.onChangeDistance}
                defaultValue={"50"}
                value={props.distance}>
                <option value="15">15 MI</option>
                <option value="25">25 MI</option>
                <option value="50">50 MI</option>
                <option value="100">100 MI</option>
            </select>
        </div>
        <div className="search-icon-container col-lg-1">
            <button className="map-search-btn" id="submit-wtb-find-service-agent">
                <svg id="submit-wtb-find-service-agent-svg" className="icon">
                    <use xlinkHref="#icon-search" />
                </svg>
                <span className="sr-only">Send</span>
            </button>
        </div>
    </form>
);

export default RepLocation;


